import { render } from "./ScrollableWrapper.vue?vue&type=template&id=7a01dc8f"
import script from "./ScrollableWrapper.vue?vue&type=script&lang=js"
export * from "./ScrollableWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__